__turbopack_context__.v({
  "actions": "NX2A1q_actions",
  "bigPreview": "NX2A1q_bigPreview",
  "blipCard": "NX2A1q_blipCard",
  "blipGrid": "NX2A1q_blipGrid",
  "blipList": "NX2A1q_blipList",
  "builder": "NX2A1q_builder",
  "builderControls": "NX2A1q_builderControls",
  "checkbox": "NX2A1q_checkbox",
  "checks": "NX2A1q_checks",
  "chip": "NX2A1q_chip",
  "code": "NX2A1q_code",
  "colourDetails": "NX2A1q_colourDetails",
  "colourGrid": "NX2A1q_colourGrid",
  "colourRow": "NX2A1q_colourRow",
  "detailHeading": "NX2A1q_detailHeading",
  "empty": "NX2A1q_empty",
  "explorer": "NX2A1q_explorer",
  "eyebrow": "NX2A1q_eyebrow",
  "favorite": "NX2A1q_favorite",
  "fieldGrid": "NX2A1q_fieldGrid",
  "filterRow": "NX2A1q_filterRow",
  "filters": "NX2A1q_filters",
  "heading": "NX2A1q_heading",
  "language": "NX2A1q_language",
  "muted": "NX2A1q_muted",
  "nativeDetail": "NX2A1q_nativeDetail",
  "nativeItem": "NX2A1q_nativeItem",
  "nativeLayout": "NX2A1q_nativeLayout",
  "nativeList": "NX2A1q_nativeList",
  "pager": "NX2A1q_pager",
  "paramTable": "NX2A1q_paramTable",
  "search": "NX2A1q_search",
  "selectedBlip": "NX2A1q_selectedBlip",
  "selectedColour": "NX2A1q_selectedColour",
  "sourceNote": "NX2A1q_sourceNote",
  "spriteChoice": "NX2A1q_spriteChoice",
  "spriteName": "NX2A1q_spriteName",
  "spriteText": "NX2A1q_spriteText",
  "spriteThumb": "NX2A1q_spriteThumb",
  "swatch": "NX2A1q_swatch",
  "wideField": "NX2A1q_wideField",
});
